import React from "react";

function HelpCards({ HELP_TOPIC_CARDS, screenSize, selectedLanguage, handleClickTopic }) {
  return (
    <div
      style={{
        maxWidth: "1200px",
        margin: "0 auto",
        padding: "0 18px",
        direction: selectedLanguage === "arabic" ? "rtl" : "ltr",
        background: "#F2F2F2",
      }}
      className="py-4"
    >
      {screenSize > 600 ? <p className="select-topic-text text-center">{selectedLanguage === "arabic" ? "إختر الموضوع" : "Select Topic"}</p> : null}

      <div className="row mx-auto" style={{ maxWidth: "780px" }}>
        {HELP_TOPIC_CARDS?.map((item, index) => {
          return (
            <div key={index} className="col-12 col-sm-3 col-md-3 mb-4 d-flex justify-content-center">
              <div
                className={`bg-white cursor-pointer d-flex ${
                  screenSize > 600
                    ? "flex-column justify-content-center align-items-center text-center"
                    : "flex-row justify-content-start align-items-center text-start"
                }    my-3 p-3 e-100 shadow-sm `}
                style={{
                  minWidth: screenSize > 600 ? "160px" : "100%",
                  height: "auto",
                  borderRadius: "5px",
                  minHeight: screenSize > 600 ? "200px" : "50px",
                  gap: screenSize > 600 ? "0px" : "1rem",
                }}
                onClick={() => handleClickTopic(item?.link)}
              >
                <img src={item?.img} style={{ width: screenSize > 600 ? "auto" : "25px" }} alt="icon" />
                <div className="help-card-text pt-4" style={{ fontSize: screenSize > 600 ? "20px" : "16px" }}>
                  {selectedLanguage === "arabic" ? item?.arabicName : item?.name}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default HelpCards;
